// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Hl-Bt","loading":"Loader_loading__7ltNQ"};